import { render, staticRenderFns } from "./BrowserHint.vue?vue&type=template&id=04a0e7d0"
import script from "./BrowserHint.vue?vue&type=script&lang=js"
export * from "./BrowserHint.vue?vue&type=script&lang=js"
import style0 from "./BrowserHint.vue?vue&type=style&index=0&id=04a0e7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports